function initSlideshows(context) {
    const slideshows = context.querySelectorAll('.zenith-slideshow');
    slideshows.forEach(slideshow => {
      const slidesWrapper = slideshow.querySelector('.slides-wrapper');
      const slides = slideshow.querySelectorAll('.slide');
      const prevButton = slideshow.querySelector('.prevSlide');
      const nextButton = slideshow.querySelector('.nextSlide');
  
      if (!slidesWrapper || slides.length === 0) return;
  
      let currentSlide = 0;
      let slideInterval;
  
      function setSlidesHeight() {
        const firstSlide = slides[0];
        const firstSlideHeight = firstSlide.offsetHeight;
        slides.forEach(slide => {
          slide.style.height = firstSlideHeight + 'px';
        });
      }
  
      function showSlide(index) {
        if (index < slides.length) {
          slidesWrapper.style.transform = `translateX(-${index * 100}%)`;
        }
      }
  
      function nextSlide() {
        currentSlide = (currentSlide + 1) % slides.length;
        showSlide(currentSlide);
        checkSlideType();
      }
  
      function prevSlide() {
        currentSlide = (currentSlide - 1 + slides.length) % slides.length;
        showSlide(currentSlide);
        checkSlideType();
      }
  
      function checkSlideType() {
        clearInterval(slideInterval);
        const currentSlideElement = slides[currentSlide];
        if (currentSlideElement.classList.contains('video-slide')) {
          let video;
          if (window.matchMedia("(max-width: 768px)").matches) {
            video = currentSlideElement.querySelector('.mobile-media video');
          } else {
            video = currentSlideElement.querySelector('.desktop-media video');
          }
          if (video) {
            video.play();
            video.addEventListener('ended', nextSlide, { once: true });
          }
        } else {
          const slideIntervalTime = parseInt(slideshow.getAttribute('data-slide-interval'), 10) * 1000;
          slideInterval = setInterval(nextSlide, slideIntervalTime);
        }
      }
  
      let startX;
      slidesWrapper.addEventListener('touchstart', function (event) {
        startX = event.touches[0].clientX;
      });
  
      slidesWrapper.addEventListener('touchend', function (event) {
        const endX = event.changedTouches[0].clientX;
        const threshold = 50;
        if (startX - endX > threshold) {
          nextSlide();
        } else if (endX - startX > threshold) {
          prevSlide();
        }
      });
  
      if (prevButton) prevButton.addEventListener('click', prevSlide);
      if (nextButton) nextButton.addEventListener('click', nextSlide);
  
      if (slideshow.classList.contains('slideshow-height-full')) {
        window.addEventListener('resize', setSlidesHeight);
        setSlidesHeight();
      }
  
      showSlide(currentSlide);
      checkSlideType();
    });
  }
  
  
  document.addEventListener('DOMContentLoaded', function () {
    initSlideshows(document);
  });
  
  
  document.addEventListener('shopify:section:load', function (event) {
    initSlideshows(event.target);
  });
  